import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AnoBase,
  CriticaGuia,
  CriticaItemGuia,
  CriticaResumo,
  JsonPreGerado,
  LinhaResumoGuia,
  LinhaResumoItemGuia,
  OperadoraCompetenciaParams,
} from '@gestor-web/@core/types';
import { HEADER_SKIP_LOAD_INTERCEPTOR } from '@gestor-web/app/shared/services';
import { environment } from '@gestor-web/environments/environment';
import { map } from 'rxjs/operators';
import { Api } from '../api';
import {
  AnalisePorPrestador,
  ApiResponse,
  Apresentacao,
  BasicResponse,
  ClasseProcedimentos,
  CompetenciaRps,
  ComparativoTissDiops,
  ConsultasEletivas,
  ConsultorioIsolado,
  ContasRepetidas,
  CriticaOperadoraIntermediaria,
  DataInclusaoCnx,
  DetalheBeneficiario,
  DetalheGuiaCriticasGuia,
  DetalheGuiaDadosInternacao,
  DetalheGuiaDadosPrincipais,
  DetalheGuiaItensGuia,
  DetalheGuiaMotivosRejeicaoGuia,
  DetalheGuiaValoresProcessamento,
  DetalheMovimentacaoGuia,
  DespesasAssistenciais,
  DespesasAssistenciaisDetalhe,
  DispersaoUrgenciaEmergencia,
  DispersaoUrgenciaEmergenciaMaxAnoBase,
  EstabelecimentoSaude,
  EstabelecimentosSaudeOpcoesFiltro,
  Exportacao,
  FiliaisAtivas,
  FornecimentoDireto,
  FornecimentoDiretoDetalhe,
  FornecimentoDiretoVisaoAnalitica,
  GuiaCnesGenerico,
  GuiaCnesIncompativel,
  GuiaIndicadorIdss,
  GuiasVinculadas,
  GuiasRejeitadas,
  GuiasRejeitadasOpcoesFiltro,
  GuiasRejeitadasResumo,
  HistoricoIdss,
  HistoricoIdssAnosBase,
  HospitaisNaoCredenciadosOpcoesFiltro,
  HospitalNaoCredenciado,
  IgrRow,
  IoRow,
  IntervaloCompetencia,
  JSON_PRE_GERADO_TIPO,
  JsonPreGeradoLinhas,
  JsonPreGeradoResponse,
  LancamentosConsolidados,
  LancamentosGerados,
  LancamentosProcessados,
  LancamentosRejeitados,
  LancamentosRejeitadosFornecimento,
  LancamentosRejeitadosFornecimentoDireto,
  LancamentosRejeitadosOutrasDespesas,
  LancamentosRejeitadosValorPre,
  LeitoCnes,
  ListagemGuia,
  ListagemGuiaParams,
  ListagemGuiasRedePropria,
  MediaBeneficiarios,
  MedicaoObservacao,
  MedicaoObservacaoLog,
  MedicaoObservacaoRequest,
  MedicaoIdss,
  MedicaoUpdate,
  MedicaoMunicipioApuracao,
  MedicaoEstabelecimentoApuracao,
  MedicaoResultadoApuracao,
  ModelosRemuneracao,
  MunicipiosRegiaoSaude,
  Nip,
  NipResumo,
  NomePlano,
  NomeRegiaoSaude,
  OperadoraCidadesAbrangidas,
  OperadoraCidadesAbrangidasFiltroItem,
  OperadoraModulo,
  OperadoraParametros,
  OperadoraPlanoSaude,
  PacoteProcedimentoProprio,
  PAGE_PARAMS_DEFAULT,
  PageParams,
  Pesquisa,
  PesquisaRespostaRequest,
  PesquisaRespostaResponse,
  PontuacaoDimensao,
  PrestadorFiltroOpcao,
  ProcedimentosElegiveis,
  ProjecaoRazaoTissDiops,
  QuantidadeGuias,
  RankingCbosConsultasEletivas,
  RankingMedicosConsultasEletivas,
  RankingMedicosConsultasEletivasGuias,
  RedimensionamentoRede,
  RejeitadosReceitaFederal,
  RejeitadosReceitaFederalFornecimento,
  ResumoDasMetricasApiItem,
  ResumoGuiasOutrasOps,
  ResumoGuiasRedePropria,
  ResumoHistoricoCriticas,
  ResumoValoresDiops,
  // ResumoPorProduto, // CU-17ttn4mqk2g
  RetornoGuia,
  RetornoItem,
  RetornoListagem,
  RpsGuiasUrgenciaEmergencia,
  RpsPrestadoresOdontologicos,
  RpsPrestadorRegistrado,
  ServicoEspecializadoCnes,
  SimuladoFiltro,
  SimuladoIdss,
  TopicoAnalise,
  UltimoProcessamento,
  UnidadeOperadora,
  URLPreAutenticada,
  ValorPreestabelecido,
} from '../ords/model';
import { RelatorioPrestadores210 } from '../ords/model/relatorio-prestadores-210';
import { RelatorioPrestadoresAcreditados26 } from '../ords/model/relatorio-prestadores-acreditados-2-6';
import { RelatorioPrestadoresAcreditados27 } from '../ords/model/relatorio-prestadores-acreditados-2-7';
import { GuiaComPacote, GuiaComPacoteProcedimentoOpcao } from '../ords/model/guias-com-pacote';
import {
  CorrecaoGuias,
  CorrecaoGuiasLog,
  CorrecaoItens,
  CorrecaoItensLog,
  DtImportacaoRetorno,
} from '../ords/model/correcao-guias';

const MODULE_PATH = '/simulador';

@Injectable({ providedIn: 'root' })
export class SimuladorGoApi extends Api {
  constructor(http: HttpClient) {
    super(`${environment.API_GO_BASE_PATH}${MODULE_PATH}`, http);
  }

  /**
   * Listagem dos simulados de uma operadora.
   */
  fetchSimuladosOperadora({ regans, ...params }: { regans: string; tp_programa_ans?: number }) {
    params = this.trimParams(params);
    return this.get<ApiResponse<SimuladoIdss>>(`/simulados/operadora/${regans}`, params);
  }

  /**
   * Busca o simulado de uma operadora pelo código do simulado.
   */
  fetchSimuladoOperadoraById(regans: string | number, cd_simulado: string | number) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}`;
    return this.get<ApiResponse<SimuladoIdss>>(path);
  }

  /**
   * Criação de um simulado.
   */
  createSimulado(regans: string, simulado: SimuladoIdss) {
    const path = `/simulados/operadora/${regans}/simulado`;
    return this.post<ApiResponse<SimuladoIdss>>(path, simulado);
  }

  /**
   * Edição de um simulado.
   */
  updateSimulado(regans: string, cd_simulado: number, simulado: SimuladoIdss) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}`;
    return this.put<ApiResponse<SimuladoIdss>>(path, simulado);
  }

  deleteSimulado(regans: string, cd_simulado: number) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}`;
    return this.delete(path);
  }

  /**
   * Edição de uma Medição,
   */
  updateMedicao(
    regans: string | number,
    cd_simulado: string | number,
    cd_medicao: string | number,
    medicao: MedicaoIdss,
  ) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_medicao}`;
    return this.put<ApiResponse<MedicaoUpdate>>(path, medicao);
  }

  /**
   * Edição com Cálculo de uma Medição,
   */
  updateAndCalculateMedicao(
    regans: string | number,
    cd_simulado: string | number,
    cd_medicao: string | number,
    medicao: MedicaoIdss,
  ) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_medicao}/calculo`;
    return this.put<ApiResponse<MedicaoUpdate>>(path, medicao);
  }

  /**
   * Cálculo de um simulado.
   */
  calcularSimulado(regans: string | number, cd_simulado: number) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/calculo`;
    return this.post<ApiResponse<void>>(path);
  }

  /**
   * Busca o histórico do IDSS de uma operadora com dados privados
   *
   * @param regans código da operadora
   */
  fetchSimuladorHistoricoIdss(regans: string, anosSelecionados: number[]) {
    if (!regans) {
      throw new Error('Required parameter regans was null when calling fetchSimuladorHistoricoIdss.');
    }
    return this.get<ApiResponse<HistoricoIdss>>(`/idss/historico/operadora/${regans}`, {
      ano_base_list: anosSelecionados.join(','),
    });
  }

  /**
   * Busca os anos-base de uma operedora
   *
   * @param regans código da operadora
   */
  fetchHistoricoIdssAnosBase(regans: string) {
    return this.get<ApiResponse<HistoricoIdssAnosBase>>(`/idss/historico/anos-base/operadora/${regans}`);
  }

  /**
   * Busca as pontuções das dimensões do IDSS de uma operadora com dados privados
   *
   * @param regans código da operadora
   */
  fetchPontuacaoDimensao(regans: string) {
    if (!regans) {
      throw new Error('Required parameter regans was null when calling fetchPontuacaoDimensao.');
    }
    return this.get<ApiResponse<PontuacaoDimensao>>(`/idss/pontuacao-dimensao/operadora/${regans}`);
  }

  fetchRankingCbosConsultasEletivas({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    ano_realizacao: number;
    id_faixa_etaria_consulta: number;
    nr_cnpj_cpf_exec?: string;
    tp_rede?: string;
    id_origem_guia?: string;
    cd_unidade_list?: string;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RankingCbosConsultasEletivas>>(
      `/analises/ranking-cbo-consultas/operadora/${regans}`,
      trimmed,
    );
  }

  fetchRankingMedicosConsultasEletivas({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    ano_realizacao: number;
    id_faixa_etaria: number;
    nr_cnpj_cpf_exec?: string;
    tp_rede?: string;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RankingMedicosConsultasEletivas>>(
      `/analises/ranking-medicos-consultas-eletivas/operadora/${regans}`,
      trimmed,
    );
  }

  fetchRankingMedicosConsultasEletivasListaGuias({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    ano_realizacao: number;
    id_faixa_etaria: number;
    cd_guia_monitor?: string;
    nr_cnpj_cpf_exec?: string;
    tp_rede?: string;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RankingMedicosConsultasEletivasGuias>>(
      `/analises/ranking-medicos-consultas-eletivas/operadora/${regans}/listagem-guias`,
      {
        ...trimmed,
      },
    );
  }

  fetchResumoGuiasRedePropria({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<ResumoGuiasRedePropria>>(
      `/analises/resumo-guias-rede-propria/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  fetchResumoGuiasRedePropriaFiliais({ regans }) {
    return this.get<ApiResponse<FiliaisAtivas>>(
      `/analises/resumo-guias-rede-propria/operadora/${regans}/filiais-ativas`,
    );
  }

  fetchListagemGuiasRedePropria({
    regans,
    competencia,
    competencia_final,
    cnpj,
    origem_guia,
    tipo_rede,
    cnes,
    tipo_guia,
  }: {
    regans: string;
    competencia: string;
    competencia_final: string;
    cnpj: string;
    origem_guia?: string;
    tipo_rede?: string;
    cnes?: string;
    tipo_guia?: number;
  }) {
    const params = this.trimParams({
      competencia,
      competencia_final,
      origem_guia,
      tipo_rede,
      cnes,
      tipo_guia,
    });
    return this.get<ApiResponse<ListagemGuiasRedePropria>>(
      `/analises/resumo-guias-rede-propria/operadora/${regans}/${cnpj}`,
      params,
    );
  }

  fetchResumoGuiasRedePropriaFiliaisUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/resumo-guias-rede-propria/operadora/${regans}/filiais-ativas/ultima-atualizacao`,
    );
  }

  fetchUnidadesOperadora(regans: string) {
    return this.get<ApiResponse<UnidadeOperadora>>(`/operadora/${regans}/unidades-negocio`);
  }

  fetchOperadoraModulosComTermino(regans: string) {
    return this.get<ApiResponse<OperadoraModulo>>(`/operadora/${regans}/modulos`).pipe(
      map(resp => resp?.items ?? []),
    );
  }

  fetchResumoGuiasOutrasOps({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<ResumoGuiasOutrasOps>>(
      `/analises/resumo-guias-outras-ops/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  fetchCriticasOperadoraIntermediaria({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<CriticaOperadoraIntermediaria>>(
      `/analises/criticas-operadora-intermediaria/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  fetchCriticasOperadoraIntermediariaUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/criticas-operadora-intermediaria/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchRejeitadosReceitaFederal({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<RejeitadosReceitaFederal>>(`/analises/rejeitados-receita-federal/operadora/${regans}`, {
      ...params,
    });
  }

  fetchLancamentosRejeitadosReceitaFederal({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    dt_nascimento: string | number;
    id_sexo: number;
    hash_cpf_cns: number;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosRejeitados>>(
      `/analises/rejeitados-receita-federal/listagem/operadora/${regans}`,
      trimmed,
    );
  }

  fetchRejeitadosReceitaFederalFornecimento({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<RejeitadosReceitaFederalFornecimento>>(
      `/analises/rejeitados-receita-federal/fornecimento/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  fetchLancamentosRejeitadosReceitaFederalFornecimento({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    dt_nascimento: string | number;
    id_sexo: number;
    hash_cpf_cns: number;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosRejeitadosFornecimento>>(
      `/analises/rejeitados-receita-federal/listagem/fornecimento/operadora/${regans}`,
      trimmed,
    );
  }

  fetchConsultasMedicasEletivas({
    regans,
    ...params
  }: OperadoraCompetenciaParams & { ano_realizacao: number; id_faixa_etaria: number; ib_critica_pendente: number }) {
    return this.get<ApiResponse<ConsultasEletivas>>(`/analises/consultas-eletivas/operadora/${regans}`, {
      ...params,
    });
  }

  fetchRetornosGuias({ regans, ...params }: OperadoraCompetenciaParams & { tp_lancto_pendente: string }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RetornoGuia>>(`/guias/retornos-ans/guias/operadora/${regans}`, trimmed);
  }

  fetchRetornosItens({ regans, ...params }: OperadoraCompetenciaParams & { tp_lancto_pendente: string }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RetornoItem>>(`/guias/retornos-ans/itens/operadora/${regans}`, trimmed);
  }

  fetchRetornoListagem({
    regans,
    ...params
  }: OperadoraCompetenciaParams & { nr_campo: number; cd_motivo_glosa: number; tp_lancto_pendente: string }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RetornoListagem>>(
      `/guias/retornos-ans/listagem/operadora/${regans}`,
      trimmed,
    );
  }

  fetchListagemGuias({ regans, ...params }: ListagemGuiaParams, page: PageParams = PAGE_PARAMS_DEFAULT) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<ListagemGuia>>(`/guias/listagem-guias/operadora/${regans}`, {
      ...trimmed,
      ...page,
    });
  }

  requestExportacaoListagemGuias(regans: string, params: Exportacao) {
    return this.post<BasicResponse>(`/guias/listagem-guias/operadora/${regans}/exportar`, params);
  }

  /**
   * Detalhe da guia/lançamento — aba "Dados principais".
   * Exige Bearer token válido (pseudonimiza CNS/CPF/cartão conforme o usuário).
   */
  fetchDetalheGuiaDadosPrincipais({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<DetalheGuiaDadosPrincipais>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/dados-principais`,
    );
  }

  /**
   * Detalhe da guia/lançamento — aba "Dados da internação".
   */
  fetchDetalheGuiaDadosInternacao({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<DetalheGuiaDadosInternacao>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/dados-internacao`,
    );
  }

  /**
   * Detalhe da guia/lançamento — aba "Valores e processamento".
   * Inclui os sub-grids modelo_remuneracao e lanctos_guia.
   */
  fetchDetalheGuiaValoresProcessamento({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<DetalheGuiaValoresProcessamento>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/valores-processamento`,
    );
  }

  /**
   * Detalhe da guia/lançamento — aba "Itens/Procedimentos da guia".
   */
  fetchDetalheGuiaItensProcedimentos({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<ApiResponse<DetalheGuiaItensGuia>>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/itens-procedimentos-guia`,
    );
  }

  /**
   * Detalhe da guia/lançamento — aba "Críticas".
   */
  fetchDetalheGuiaCriticas({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<ApiResponse<DetalheGuiaCriticasGuia>>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/criticas`,
    );
  }

  /**
   * Detalhe da guia/lançamento — aba "Motivos de rejeição".
   */
  fetchDetalheGuiaMotivosRejeicao({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<ApiResponse<DetalheGuiaMotivosRejeicaoGuia>>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/motivos-rejeicao`,
    );
  }

  /**
   * Detalhe da guia/lançamento — aba "Movimentação".
   */
  fetchMovimentacaoGuia({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<ApiResponse<DetalheMovimentacaoGuia>>(
      `/guias/operadora/${regans}/lancamentos/${cd_guia_monitor}/movimentacao`,
    );
  }

  fetchDetalhesBeneficiario({ regans, nr_guia_monitor }: { regans: string; nr_guia_monitor: string }) {
    return this.get<ApiResponse<DetalheBeneficiario>>(
      `/beneficiarios/operadora/${regans}/beneficiario-guia/${nr_guia_monitor}`,
    );
  }

  fetchRedimensionamentoRede({
    regans,
    nr_registro_plano,
    cd_regiao_saude,
    cd_categoria_servico,
  }: {
    regans: string;
    nr_registro_plano: number;
    cd_regiao_saude: number;
    cd_categoria_servico: string;
  }) {
    const trimmed = this.trimParams({ nr_registro_plano, cd_regiao_saude, cd_categoria_servico });
    return this.get<ApiResponse<RedimensionamentoRede>>(
      `/analises/redimensionamento-rede/operadora/${regans}`,
      trimmed,
    );
  }

  fetchAnalisePorPrestador({
    regans,
    nr_cpf_cnpj,
    cd_categoria_servico,
    cd_regiao_saude,
  }: {
    regans: string;
    nr_cpf_cnpj: string;
    cd_categoria_servico: string;
    cd_regiao_saude?: string | number;
  }) {
    const trimmed = this.trimParams({ nr_cpf_cnpj, cd_categoria_servico, cd_regiao_saude });
    return this.get<ApiResponse<AnalisePorPrestador>>(
      `/analises/redimensionamento-rede/operadora/${regans}/analise-por-prestador`,
      trimmed,
    );
  }

  fetchPrestadoresAnalisePorPrestador({
    regans,
    cd_categoria_servico,
  }: {
    regans: string;
    cd_categoria_servico?: string;
  }) {
    const trimmed = this.trimParams({ cd_categoria_servico });
    return this.get<ApiResponse<PrestadorFiltroOpcao>>(
      `/analises/redimensionamento-rede/operadora/${regans}/prestadores`,
      trimmed,
    );
  }

  fetchMunicipiosRegiaoSaude({ regans }) {
    return this.get<ApiResponse<MunicipiosRegiaoSaude>>(
      `/analises/municipios-regiao-saude/operadora/${regans}`,
    );
  }

  fetchNomePlano({ regans }) {
    return this.get<ApiResponse<NomePlano>>(`/analises/nome-plano/operadora/${regans}`);
  }

  fetchNomeRegiaoSaude({ regans }) {
    return this.get<ApiResponse<NomeRegiaoSaude>>(`/analises/nome-regiao-saude/operadora/${regans}`);
  }

  fetchIntervaloCompetencia({ regans }) {
    return this.get<ApiResponse<IntervaloCompetencia>>(
      `/analises/redimensionamento-rede/operadora/${regans}/intervalo-competencia`,
    );
  }

  fetchHospitaisNaoCredenciados({
    regans,
    cd_regiao_saude,
    cd_municipio,
    ds_atributo_qualidade,
  }: {
    regans: string;
    cd_regiao_saude: string;
    cd_municipio?: string;
    ds_atributo_qualidade?: string;
  }) {
    const trimmed = this.trimParams({ cd_regiao_saude, cd_municipio, ds_atributo_qualidade });
    return this.get<ApiResponse<HospitalNaoCredenciado>>(
      `/analises/redimensionamento-rede/operadora/${regans}/hospitais-nao-credenciados`,
      trimmed,
    );
  }

  fetchHospitaisNaoCredenciadosOpcoesFiltro({ regans, cd_regiao_saude }: { regans: string; cd_regiao_saude?: string }) {
    const trimmed = this.trimParams({ cd_regiao_saude });
    return this.get<HospitaisNaoCredenciadosOpcoesFiltro>(
      `/analises/redimensionamento-rede/operadora/${regans}/hospitais-nao-credenciados/opcoes-filtro`,
      trimmed,
    );
  }

  fetchHospitaisNaoCredenciadosLeitos({ regans, nr_cnes }: { regans: string; nr_cnes: string }) {
    return this.get<ApiResponse<LeitoCnes>>(
      `/analises/redimensionamento-rede/operadora/${regans}/hospitais-nao-credenciados/leitos`,
      { nr_cnes },
    );
  }

  fetchEstabelecimentosSaude({
    regans,
    cd_regiao_saude,
    cd_tipo_estabelecimento,
    ib_registro_rps,
    cd_categoria_servico,
  }: {
    regans: string;
    cd_regiao_saude: string | number;
    cd_tipo_estabelecimento?: string;
    ib_registro_rps?: string;
    cd_categoria_servico?: string;
  }) {
    const trimmed = this.trimParams({
      cd_regiao_saude,
      cd_tipo_estabelecimento,
      ib_registro_rps,
      cd_categoria_servico,
    });
    return this.get<ApiResponse<EstabelecimentoSaude>>(
      `/analises/redimensionamento-rede-nao-hospitalar/operadora/${regans}/estabelecimentos-saude`,
      trimmed,
    );
  }

  fetchEstabelecimentosSaudeOpcoesFiltro({
    regans,
    cd_regiao_saude,
  }: {
    regans: string;
    cd_regiao_saude?: string | number;
  }) {
    const trimmed = this.trimParams({ cd_regiao_saude });
    return this.get<EstabelecimentosSaudeOpcoesFiltro>(
      `/analises/redimensionamento-rede-nao-hospitalar/operadora/${regans}/opcoes-filtro`,
      trimmed,
    );
  }

  fetchEstabelecimentosSaudeIntervaloCompetencia({ regans }: { regans: string }) {
    return this.get<ApiResponse<IntervaloCompetencia>>(
      `/analises/redimensionamento-rede-nao-hospitalar/operadora/${regans}/intervalo-competencia`,
    );
  }

  fetchConsultorioIsolado({
    regans,
    cd_regiao_saude,
    ib_registro_rps,
    cd_categoria_servico,
  }: {
    regans: string;
    cd_regiao_saude: string | number;
    ib_registro_rps?: string;
    cd_categoria_servico?: string;
  }) {
    const trimmed = this.trimParams({
      cd_regiao_saude,
      ib_registro_rps,
      cd_categoria_servico,
    });
    return this.get<ApiResponse<ConsultorioIsolado>>(
      `/analises/redimensionamento-rede-nao-hospitalar/consultorio-isolado/operadora/${regans}`,
      trimmed,
    );
  }

  fetchConsultorioIsoladoRegioesSaude({ regans }: { regans: string }) {
    return this.get<ApiResponse<NomeRegiaoSaude>>(
      `/analises/redimensionamento-rede-nao-hospitalar/consultorio-isolado/operadora/${regans}/regioes-saude`,
    );
  }

  fetchContagemGuias({ regans, nr_cpf_cnpj }: { regans: string; nr_cpf_cnpj?: string }) {
    const trimmed = this.trimParams({ nr_cpf_cnpj });
    return this.get<ApiResponse<QuantidadeGuias>>(`/analises/contagem-guias/operadora/${regans}`, trimmed);
  }

  fetchDispersaoUrgenciaEmergenciaMaxAnoBase({ regans }: { regans: string }) {
    return this.get<ApiResponse<DispersaoUrgenciaEmergenciaMaxAnoBase>>(
      `/analises/dispersao-urgencia-emergencia/operadora/${regans}/max-ano-base`,
    );
  }

  fetchDispersaoUrgenciaEmergencia({ regans, ...params }) {
    return this.get<ApiResponse<DispersaoUrgenciaEmergencia>>(
      `/analises/dispersao-urgencia-emergencia/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  fetchRpsGuiasUrgenciaEmergencia({
    regans,
    ...params
  }: {
    regans: string;
    competencia: string;
    competencia_final: string;
    situacao_rps?: number[];
  }) {
    return this.get<{ items: RpsGuiasUrgenciaEmergencia[] }>(
      `/analises/rps-guias-urgencia-emergencia/operadora/${regans}`,
      this.trimParams(params),
    );
  }

  fetchRpsGuiasUrgenciaEmergenciaUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/rps-guias-urgencia-emergencia/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchRpsPrestadoresOdontologicos({ regans, ...params}: { regans: string; competencia: string; competencia_final: string; registro_rps?: number; }) {
    return this.get<{ items: RpsPrestadoresOdontologicos[] }>(
      `/analises/rps-prestadores-odontologicos/operadora/${regans}`,
      this.trimParams(params),
    );
  }

  fetchRpsPrestadoresRegistrados({
    regans,
    ...params
  }: {
    regans: string;
    id_classificacao?: string;
    sn_urgencia_emergencia?: string;
    tp_relacao_operadora?: string;
    tp_contratualizacao?: string;
    nr_cpf_cnpj?: string;
    nr_cnes?: string;
    nr_registro_plano?: string;
    page?: number;
    size?: number;
  }) {
    return this.get<ApiResponse<RpsPrestadorRegistrado>>(
      `/analises/rps-prestadores-registrados/operadora/${regans}`,
      this.trimParams(params),
    );
  }

  fetchCompetenciaRps({ regans }) {
    return this.get<ApiResponse<CompetenciaRps>>(
      `/analises/dispersao-urgencia-emergencia/operadora/${regans}/competencia-rps`,
    );
  }

  fetchProcedimentosElegiveis({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<ProcedimentosElegiveis>>(
      `/analises/procedimentos-elegiveis/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  fetchClassesProcedimentos({ regans }: { regans: string }) {
    return this.get<ApiResponse<ClasseProcedimentos>>(
      `/analises/procedimentos-elegiveis/operadora/${regans}/classes`,
    );
  }

  fetchUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/procedimentos-elegiveis/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchResumoDasMetricas({ regans }: { regans: string }) {
    return this.get<ApiResponse<ResumoDasMetricasApiItem>>(
      `/operadoras/operadora/${regans}/resumo-das-metricas`,
    );
  }

  fetchMediaBeneficiarios({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<MediaBeneficiarios>>(
      `/operadoras/operadora/${regans}/media-de-beneficiarios`,
      {
        ...params,
      },
    );
  }

  // CU-17ttn4mqk2g
  // fetchResumoPorProduto({ regans }: { regans: string }) {
  //   return this.get<ApiResponse<ResumoPorProduto>>(`/operadoras/operadora/${regans}/resumo-por-produto`);
  // }

  fetchDataInclusaoCnx({ regans }) {
    return this.get<ApiResponse<DataInclusaoCnx>>(
      `/operadoras/operadora/${regans}/resumo-do-cnx/data-inclusao`,
    );
  }

  fetchContasRepetidas({
    regans,
    condicao,
    data_realizacao,
    page,
    size,
    ...params
  }: OperadoraCompetenciaParams & { condicao: string; data_realizacao: string; page?: number; size?: number }) {
    return this.get<ApiResponse<ContasRepetidas>>(
      `/analises/conformidade/contas-repetidas/operadora/${regans}`,
      {
        ...params,
        condicao,
        data_realizacao,
        page,
        size,
      },
    );
  }

  requestExportacaoContasRepetidas(regans: string, params: Exportacao) {
    return this.post<BasicResponse>(
      `/analises/conformidade/contas-repetidas/operadora/${regans}/exportar`,
      params,
    );
  }

  fetchContasRepetidasUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/conformidade/contas-repetidas/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchGuiasRejeitadas({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    page?: number;
    size?: number;
    tp_seq_lancto?: string | null;
    motivo_guia?: string[];
    motivo_item?: string[];
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<GuiasRejeitadas>>(
      `/analises/conformidade/guias-rejeitadas/operadora/${regans}`,
      trimmed,
    );
  }

  fetchGuiasRejeitadasAgregado({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    tp_seq_lancto?: string | null;
    motivo_guia?: string[];
    motivo_item?: string[];
  }) {
    const trimmed = this.trimParams(params);
    return this.get<GuiasRejeitadasResumo>(
      `/analises/conformidade/guias-rejeitadas/operadora/${regans}/agregado`,
      trimmed,
    );
  }

  fetchGuiasRejeitadasUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/conformidade/guias-rejeitadas/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchGuiasRejeitadasResumoUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/conformidade/guias-rejeitadas/operadora/${regans}/resumo/ultima-atualizacao`,
    );
  }

  fetchGuiasRejeitadasOpcoesFiltro({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<{ items: GuiasRejeitadasOpcoesFiltro }>(
      `/analises/conformidade/guias-rejeitadas/operadora/${regans}/opcoes-filtro`,
      { ...params },
    );
  }

  requestExportacaoGuiasRejeitadas(regans: string, params: Exportacao) {
    return this.post<BasicResponse>(`/analises/conformidade/guias-rejeitadas/operadora/${regans}/exportar`, params);
  }

  fetchPrestadorExecutanteReceitaFederal(regans: string, nrCnpj: string) {
    return this.get<ApiResponse<ProcedimentosElegiveis>>(
      `/prestadores/prestador-guia/receita-federal/operadora/${regans}/${nrCnpj}`,
    );
  }

  fetchPrestadorExecutanteDadosCnes(regans: string, nrCnpj?: string, nrCnesExec?: string) {
    return this.get<ApiResponse<ProcedimentosElegiveis>>(
      `/prestadores/prestador-guia/dados-cnes/operadora/${regans}/${nrCnpj}`,
      { nr_cnes_exec: nrCnesExec || '' },
    );
  }

  fetchPrestadorExecutanteLeitosCnes(regans: string, nrCnes: string) {
    return this.get<ApiResponse<LeitoCnes>>(`/prestadores/prestador-guia/dados-cnes-leitos/operadora/${regans}/${nrCnes}`);
  }

  fetchPrestadorExecutanteServicosEspecializadosCnes(regans: string, nrCnes: string) {
    return this.get<ApiResponse<ServicoEspecializadoCnes>>(
      `/prestadores/prestador-guia/dados-cnes-servicos-especializados/operadora/${regans}/${nrCnes}`,
    );
  }

  fetchPrestadorExecutanteDadosRps(regans: string, nrCnpj?: string, nrRegistroPlano?: string) {
    return this.get<ApiResponse<ProcedimentosElegiveis>>(
      `/prestadores/prestador-guia/dados-rps/operadora/${regans}/${nrCnpj}`,
      { nr_registro_plano: nrRegistroPlano || '' },
    );
  }

  fetchPrestadorExecutanteDadosMedico(regans: string, nrCnpj: string) {
    return this.get<ApiResponse<ProcedimentosElegiveis>>(
      `/prestadores/prestador-guia/dados-medico/operadora/${regans}/${nrCnpj}`,
    );
  }

  fetchPrestadorExecutanteDadosAtributosQualidade(regans: string, nrCnpj: string) {
    return this.get<ApiResponse<ProcedimentosElegiveis>>(
      `/prestadores/prestador-guia/dados-atributos-qualidade/operadora/${regans}/${nrCnpj}`,
    );
  }

  fetchLancamentosConsolidados({ regans, ...params }: OperadoraCompetenciaParams) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosConsolidados>>(
      `/guias/lancamentos-consolidados/operadora/${regans}`,
      trimmed,
    );
  }

  fetchLancamentosConsolidadosUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/guias/lancamentos-consolidados/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchLancamentosProcessados({ regans, ...params }: OperadoraCompetenciaParams) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosProcessados>>(
      `/guias/lancamentos-guias/operadora/${regans}`,
      trimmed,
    );
  }

  fetchDtImportacaoRetorno(regans: string) {
    return this.get<ApiResponse<DtImportacaoRetorno>>(
      `/guias/lancamentos-guias/operadora/${regans}/dt-importacao-retorno`,
    );
  }

  fetchCorrecaoGuiasAnsRfb({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<CorrecaoGuias>>(
      `/guias/lancamentos-guias/operadora/${regans}/retornos-ans/ans-rfb`,
      {
        ...params,
      },
    );
  }

  fetchCorrecaoGuiasCnpjCpfInvalido({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<CorrecaoGuias>>(
      `/guias/lancamentos-guias/operadora/${regans}/retornos-ans/cnpj-cpf-invalido`,
      {
        ...params,
      },
    );
  }

  fetchCorrecaoItens({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<CorrecaoItens>>(
      `/guias/lancamentos-itens-guias/operadora/${regans}/retornos-ans`,
      {
        ...params,
      },
    );
  }

  fetchCorrecaoGuiasLog(regans: string, cd_guia_monitor: string) {
    return this.get<ApiResponse<CorrecaoGuiasLog>>(
      `/guias/lancamentos-guias/operadora/${regans}/${cd_guia_monitor}/log`,
    );
  }

  fetchCorrecaoItensLog(regans: string, cd_guia_monitor: string) {
    return this.get<ApiResponse<CorrecaoItensLog>>(
      `/guias/lancamentos-itens-guias/operadora/${regans}/${cd_guia_monitor}/log`,
    );
  }

  updateCorrecaoGuia(
    regans: string,
    cd_guia_monitor: string,
    data: {
      nr_cpf_beneficiario: string;
      nr_cns: string;
      id_sexo: string;
      dt_nascimento: string | number;
      alterado?: boolean;
    },
  ) {
    const path = `/guias/lancamentos-guias/operadora/${regans}/${cd_guia_monitor}`;
    return this.put(path, data);
  }

  updateCorrecaoItens(
    regans: string,
    cd_guia_monitor: string,
    cd_proced_item: string,
    data: {
      cd_dente: string;
      alterado?: boolean;
    },
  ) {
    const path = `/guias/lancamentos-itens-guias/operadora/${regans}/${cd_guia_monitor}`;
    return this.put(path, {
      ...data,
      cd_proced_item,
    });
  }

  fetchLancamentosGerados({ regans, ...params }: OperadoraCompetenciaParams) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosGerados>>(
      `/guias/lancamentos-gerados/operadora/${regans}`,
      trimmed,
    );
  }

  fetchDadosResumoHistoricoCriticas({
    regans,
    ...params
  }: {
    regans: string;
    nr_anobase: number;
    critica?: string;
    tp_impacto?: string;
    competencia?: string;
    competencia_final?: string;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<ResumoHistoricoCriticas>>(`/guias/historico/operadora/${regans}`, trimmed);
  }

  fetchDadosCriticaResumo({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    tp_seq_lancto?: string;
    st_critica?: string;
    id_bloco_info?: string;
    cd_unidade_list?: string;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<CriticaResumo>>(`/guias/criticas/resumo-evolucao/operadora/${regans}`, {
      ...trimmed,
    });
  }

  fetchDadosCriticaListagemGuias(
    {
      regans,
      ...params
    }: OperadoraCompetenciaParams & {
      codcritica: number;
      tp_seq_lancto?: string;
      cd_unidade_list?: string;
      st_critica?: string;
    },
    page: PageParams = PAGE_PARAMS_DEFAULT,
  ) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<CriticaGuia>>(`/guias/criticas/listagem-guias/operadora/${regans}`, {
      page: Math.floor(page.offset / page.limit),
      size: page.limit,
      ...trimmed,
    });
  }

  fetchDadosCriticaListagemItensGuias(
    {
      regans,
      ...params
    }: OperadoraCompetenciaParams & {
      codcritica: number;
      tp_seq_lancto?: string;
      cd_unidade_list?: string;
      st_critica?: string;
    },
    page: PageParams = PAGE_PARAMS_DEFAULT,
  ) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<CriticaItemGuia>>(`/guias/criticas/listagem-itens-guias/operadora/${regans}`, {
      page: Math.floor(page.offset / page.limit),
      size: page.limit,
      ...trimmed,
    });
  }

  fetchMedicoesDetalhesApuracao(filter: { regans: string | number; cd_simulado: string | number }) {
    const { regans, cd_simulado } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes`;
    return this.get<ApiResponse<MedicaoIdss>>(path);
  }

  /**
   * Listagem dos valores/medicoes de um determinado simulado
   */
  fetchMedicoesSimuladoOperadoraById(regans: string | number, cd_simulado: string | number) {
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/valores`;
    return this.get<ApiResponse<MedicaoIdss>>(path);
  }

  fetchGuiasIndicador(filter: {
    regans: string | number;
    cd_simulado: string | number;
    cd_indicador: string | number;
    page?: number;
    size?: number;
  }) {
    const { regans, cd_simulado, cd_indicador, page, size } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/guias-apuradas`;
    return this.get<ApiResponse<GuiaIndicadorIdss>>(path, { page, size });
  }

  fetchResultadosApuracao(filter: {
    regans: string | number;
    cd_simulado: string | number;
    cd_indicador: string | number;
    page?: number;
    size?: number;
  }) {
    const { regans, cd_simulado, cd_indicador, page, size } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/prestadores-apurados`;
    return this.get<ApiResponse<MedicaoResultadoApuracao>>(path, { page, size });
  }

  fetchMunicipiosApurados(filter: {
    regans: string | number;
    cd_simulado: string | number;
    cd_indicador: string | number;
    page?: number;
    size?: number;
  }) {
    const { regans, cd_simulado, cd_indicador, page, size } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/municipios-apurados`;
    return this.get<ApiResponse<MedicaoMunicipioApuracao>>(path, { page, size });
  }

  fetchEstabelecimentosApurados(filter: {
    regans: string | number;
    cd_simulado: string | number;
    cd_indicador: string | number;
    page?: number;
    size?: number;
  }) {
    const { regans, cd_simulado, cd_indicador, page, size } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/estabelecimentos-apurados`;
    return this.get<ApiResponse<MedicaoEstabelecimentoApuracao>>(path, { page, size });
  }

  requestExportacaoDetalhesApuracao(regans: string, params: Exportacao) {
    return this.post<BasicResponse>(`/simulados/operadora/${regans}/detalhes-apuracao/exportar`, params);
  }

  fetchObservacoesSimulado(filter: { regans: string | number; cd_simulado: string | number }) {
    const { regans, cd_simulado } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/observacoes`;
    return this.get<ApiResponse<MedicaoObservacao>>(path);
  }

  fetchTopicosAnalise(filter: { regans: string | number; cd_simulado: string | number }) {
    const { regans, cd_simulado } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/topicos-analise`;
    return this.get<ApiResponse<TopicoAnalise>>(path);
  }

  updateObservacaoMedicao(
    filter: { regans: string | number; cd_simulado: string | number; cd_indicador: string | number },
    observacao: MedicaoObservacaoRequest,
  ) {
    const { regans, cd_simulado, cd_indicador } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/observacao`;
    return this.put<void>(path, observacao);
  }

  registrarLogMedicao(
    filter: {
      regans: string | number;
      cd_simulado: string | number;
      cd_indicador: string | number;
    },
    snapshot: { vl_resultado: number | null; vl_pontuacao: number | null },
  ) {
    const { regans, cd_simulado, cd_indicador } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/log`;
    return this.post<void>(path, snapshot);
  }

  fetchObservacaoMedicaoLog(filter: {
    regans: string | number;
    cd_simulado: string | number;
    cd_indicador: string | number;
  }) {
    const { regans, cd_simulado, cd_indicador } = filter;
    const path = `/simulados/operadora/${regans}/simulado/${cd_simulado}/medicoes/${cd_indicador}/observacao/log`;
    return this.get<ApiResponse<MedicaoObservacaoLog>>(path);
  }

  fetchPlanosSaude(regans: string) {
    return this.get<ApiResponse<OperadoraPlanoSaude>>(`/operadoras/operadora/${regans}/planos-saude`);
  }

  fetchApresentacoes(regans: string, dt_inclusao_desde: string) {
    const params = this.trimParams({ dt_inclusao_desde });
    return this.get<ApiResponse<Apresentacao>>(`/operadoras/operadora/${regans}/apresentacoes`, params);
  }

  /** URL pré-autenticada (2h) para exibir o material no navegador, sem o token do Keycloak. */
  fetchUrlApresentacao(regans: string, cd_arquivo: number) {
    return this.get<URLPreAutenticada>(`/operadoras/operadora/${regans}/apresentacoes/${cd_arquivo}/url`);
  }

  fetchCidadesAbrangidas(
    regans: string,
    filtros: {
      nr_registro_plano?: string;
      sgmt_assistencial?: string;
      contratacao?: string;
      id_vigencia_plano?: string;
      situacao_plano?: string;
    },
  ) {
    const params = this.trimParams(filtros);
    return this.get<ApiResponse<OperadoraCidadesAbrangidas>>(
      `/operadoras/operadora/${regans}/cidades-abrangidas`,
      params,
    );
  }

  fetchFiltrosCidadesAbrangidas(regans: string) {
    return this.get<ApiResponse<OperadoraCidadesAbrangidasFiltroItem>>(
      `/operadoras/operadora/${regans}/cidades-abrangidas/filtros`,
    );
  }

  fetchPacotesProcedimentosProprios(regans: string) {
    return this.get<ApiResponse<PacoteProcedimentoProprio>>(
      `/operadoras/operadora/${regans}/pacotes-procedimentos-proprios`,
    );
  }

  createPacotesProcedimentosProprios(regans: string, pacote: PacoteProcedimentoProprio) {
    return this.post<void>(`/operadoras/operadora/${regans}/pacotes-procedimentos-proprios`, pacote);
  }

  updatePacotesProcedimentosProprios(regans: string, cd_item_proprio: string, pacote: PacoteProcedimentoProprio) {
    return this.put<void>(`/operadoras/operadora/${regans}/pacotes-procedimentos-proprios/${cd_item_proprio}`, pacote);
  }

  deletePacotesProcedimentosProprios(regans: string, cd_item_proprio: string, dt_alteracao: string) {
    return this.delete(`/operadoras/operadora/${regans}/pacotes-procedimentos-proprios/${cd_item_proprio}`, {
      params: this.trimParams({ dt_alteracao }),
    });
  }

  fetchFornecimentoDireto({ regans, ...params }: OperadoraCompetenciaParams & { page?: number; size?: number }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<FornecimentoDireto>>(
      `/remuneracao/outras-remuneracoes/operadora/${regans}/fornecimento-direto/lancamentos`,
      trimmed,
    );
  }

  fetchFornecimentoDiretoVisaoAnalitica({ regans, ...params }: OperadoraCompetenciaParams) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<FornecimentoDiretoVisaoAnalitica>>(
      `/remuneracao/outras-remuneracoes/operadora/${regans}/fornecimento-direto/visao-analitica`,
      trimmed,
    );
  }

  fetchDetalhesFornecimentoDireto({ regans, cd_guia_monitor }: { regans: string; cd_guia_monitor: string }) {
    return this.get<FornecimentoDiretoDetalhe>(
      `/remuneracao/outras-remuneracoes/operadora/${regans}/fornecimento-direto/detalhe/${cd_guia_monitor}`,
    );
  }

  fetchDespesasAssistenciais({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<DespesasAssistenciais>>(
      `/remuneracao/outras-remuneracoes/operadora/${regans}/outras-despesas-assistenciais/lancamentos`,
      params,
    );
  }

  fetchDespesasAssistenciaisDetalhe(regans: string, cd_guia_monitor: string) {
    return this.get<DespesasAssistenciaisDetalhe>(
      `/remuneracao/outras-remuneracoes/operadora/${regans}/outras-despesas-assistenciais/lancamentos/${cd_guia_monitor}`,
    );
  }

  fetchValorPreestabelecido({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<ValorPreestabelecido>>(
      `/remuneracao/outras-remuneracoes/valor-preestabelecido/operadora/${regans}`,
      params,
    );
  }

  fetchValorPreestabelecidoGuiasVinculadas(
    regans: string,
    nr_contrato_valor_pre: string,
    nr_competencia_cobertura: string,
  ) {
    return this.get<ApiResponse<GuiasVinculadas>>(
      `/remuneracao/outras-remuneracoes/valor-preestabelecido/operadora/${regans}/guias-vinculadas/contrato/${nr_contrato_valor_pre}`,
      { nr_competencia_cobertura },
    );
  }

  fetchComparativoTissDiops({ regans, competencia }: { regans: string; competencia: number }) {
    return this.get<ApiResponse<ComparativoTissDiops>>(`/remuneracao/diops/operadora/${regans}`, {
      nr_ano_base: competencia,
    });
  }

  fetchResumoValoresDiops({ regans, competencia }: { regans: string; competencia: number }) {
    return this.get<ApiResponse<ResumoValoresDiops>>(`/remuneracao/valor-informado-tiss/operadora/${regans}`, {
      nr_ano_base: competencia,
    });
  }

  fetchProjecaoRazaoTissDiopsProtocolo({ regans, competencia }: { regans: string; competencia: number }) {
    return this.get<ApiResponse<ProjecaoRazaoTissDiops>>(
      `/remuneracao/razao-tiss-diops-protocolo/operadora/${regans}`,
      {
        nr_ano_base: competencia,
      },
    );
  }

  fetchLancamentosRejeitadosValorPre({ regans, ...params }: OperadoraCompetenciaParams) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosRejeitadosValorPre>>(
      `/analises/incorporacao-dados/lancamentos-rejeitados-valor-pre/operadora/${regans}`,
      trimmed,
    );
  }

  fetchLancamentosRejeitadosOutrasDespesas({
    regans,
    ...params
  }: OperadoraCompetenciaParams & { filtro_motivo_arquivo?: string; filtro_critica_guia?: string }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosRejeitadosOutrasDespesas>>(
      `/analises/incorporacao-dados/lancamentos-rejeitados-outras-despesas-assistenciais/operadora/${regans}`,
      trimmed,
    );
  }

  fetchLancamentosRejeitadosFornecimentoDireto({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    tp_seq_lancto?: string;
    filtro_motivo_arquivo?: string;
    filtro_critica_guia?: string;
    filtro_critica_item?: string;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<LancamentosRejeitadosFornecimentoDireto>>(
      `/analises/incorporacao-dados/lancamentos-rejeitados-fornecimento-direto/operadora/${regans}`,
      trimmed,
    );
  }

  fetchListagemNips(
    regans: string,
    page?: number,
    size?: number,
    competenciaInicial?: string,
    competenciaFinal?: string,
  ) {
    return this.get<ApiResponse<Nip>>(`/nips/operadora/${regans}`, {
      page,
      size,
      competencia_inicial: competenciaInicial,
      competencia_final: competenciaFinal,
    });
  }

  fetchResumoNips(regans: string, competenciaInicial?: string, competenciaFinal?: string) {
    return this.get<ApiResponse<NipResumo>>(`/nips/operadora/${regans}/resumo`, {
      competencia_inicial: competenciaInicial,
      competencia_final: competenciaFinal,
    });
  }

  fetchNipsIndicadores(regans: string, anoBase: number) {
    return this.get<ApiResponse<any>>(`/nips/operadora/${regans}/indicadores`, {
      ano_base: anoBase,
    });
  }

  fetchNipsIgr(regans: string, anoBase: number) {
    return this.get<ApiResponse<IgrRow>>(`/nips/operadora/${regans}/igr`, {
      ano_base: anoBase,
    });
  }

  fetchNipsIo(regans: string, anoBase: number) {
    return this.get<ApiResponse<IoRow>>(`/nips/operadora/${regans}/io`, {
      ano_base: anoBase,
    });
  }

  fetchSimuladosFiltro({ regans, anoBase }: { regans: string | number; anoBase: number }) {
    return this.get<ApiResponse<SimuladoFiltro>>(`/simulados/operadora/${regans}/filtro`, { anoBase });
  }

  fetchParametorsOperadora(regans: string) {
    const path = `/parametros/operadora/${regans}`;
    return this.get<OperadoraParametros>(path);
  }

  // GET /simulador/pesquisa/:cd_pesquisa/operadora/:operadora — objeto único (bare).
  // Diálogo do layout: fora do interceptor, para a navegação não cancelar a pesquisa.
  fetchPesquisa(cdPesquisa: number, regans: string) {
    return this.http.get<Pesquisa>(`${this.basePath}/pesquisa/${cdPesquisa}/operadora/${regans}`, {
      headers: { [HEADER_SKIP_LOAD_INTERCEPTOR]: 'true' },
    });
  }

  // POST /simulador/pesquisa/:cd_pesquisa/operadora/:operadora/resposta — retorna { cd_resposta }.
  saveRespostaPesquisa(cdPesquisa: number, regans: string, resposta: PesquisaRespostaRequest) {
    return this.post<PesquisaRespostaResponse>(`/pesquisa/${cdPesquisa}/operadora/${regans}/resposta`, resposta);
  }
  
  fetchRelatorioPrestadores210({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    fil_rps?: string;
    fil_acreditado?: number;
    fil_participacao_ab?: number;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RelatorioPrestadores210>>(
      `/analises/relatorio-prestadores-2-10/operadora/${regans}`,
      trimmed,
    );
  }

  fetchRelatorioPrestadores210UltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/relatorio-prestadores-2-10/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchRelatorioPrestadoresAcreditados26({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    fil_180_dias?: number;
    fil_acreditado?: number;
    fil_rps?: string;
    fil_elegivel?: number;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RelatorioPrestadoresAcreditados26>>(
      `/analises/relatorio-prestadores-acreditados-2-6/operadora/${regans}`,
      trimmed,
    );
  }

  fetchRelatorioPrestadoresAcreditados26UltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/relatorio-prestadores-acreditados-2-6/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchRelatorioPrestadoresAcreditados27({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    fil_acreditado?: number;
    fil_180_dias?: number;
    fil_rps?: number;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<RelatorioPrestadoresAcreditados27>>(
      `/analises/relatorio-prestadores-2-7/operadora/${regans}`,
      trimmed,
    );
  }

  fetchRelatorioPrestadoresAcreditados27UltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/relatorio-prestadores-2-7/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchGuiasComPacote({
    regans,
    ...params
  }: OperadoraCompetenciaParams & {
    cd_tabela_tuss?: string;
    cd_proced_item?: string;
    page?: number;
    size?: number;
  }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<GuiaComPacote>>(
      `/analises/conformidade/guias-com-pacote/operadora/${regans}`,
      trimmed,
    );
  }

  fetchProcedimentosGuiaComPacote({
    regans,
    ...params
  }: OperadoraCompetenciaParams & { cd_tabela_tuss?: string }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<GuiaComPacoteProcedimentoOpcao>>(
      `/analises/conformidade/guias-com-pacote/operadora/${regans}/procedimentos`,
      trimmed,
    );
  }

  fetchGuiasComPacoteUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/conformidade/guias-com-pacote/operadora/${regans}/ultima-atualizacao`,
    );
  }

  fetchModelosRemuneracao({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<ModelosRemuneracao>>(
      `/analises/conformidade/modelos-remuneracao/operadora/${regans}`,
      {
        ...params,
      },
    );
  }

  /**
   * Retorna os Anos Bases de uma operadora
   */
  fetchAnosBases(regans: string) {
    const actualPath = '/geral/config/anos-bases/operadora/' + regans;
    // O endpoint devolve um item com `anobase` nulo na frente da lista; descartar aqui evita
    // repetir o filtro em cada tela. Ver go-api.spec.ts.
    return this.get<ApiResponse<AnoBase>>(actualPath).pipe(
      map(resp => resp.items.map(item => item.anobase).filter(ano => ano != null)),
    );
  }

  /**
   * Busca dos dados com JSON pré-gerado.
   *
   * Inativo: os JSONs gerados desde out/2026 ficam só no bucket, com `ARQ_JSON.CL_JSON` nulo, e o Go
   * ainda lê só essa coluna. Até ler do bucket, a busca vai pelo `SimuladorApi` (ORDS), que já lê de lá.
   */
  fetchDadosJsonPreGerado<T extends JsonPreGeradoLinhas>(
    regans: string | number,
    consulta: JSON_PRE_GERADO_TIPO,
    filtro: { anobase?: number; anobase_competencia?: number; competencia?: string; valorcampochave?: number },
  ) {
    const path = `/consuta-json-pre-gerado/operadora/${regans}/consulta/${consulta}`;
    return this.get<ApiResponse<JsonPreGeradoResponse<T>>>(path, filtro);
  }

  /**
   * Busca os dados do Resumo de Guias com JSON pré-gerado.
   *
   * Inativo pelo mesmo motivo do `fetchDadosJsonPreGerado`.
   */
  fetchDadosResumoGuiasCuboJsonPreGerado({
    regans,
    ...params
  }: OperadoraCompetenciaParams & { cd_unidade_list?: string }) {
    const trimmed = this.trimParams(params);
    return this.get<ApiResponse<JsonPreGerado<LinhaResumoGuia>>>(
      `/consuta-json-pre-gerado/operadora/${regans}/consulta/MON_CR_GUIA_RESUMO_V202403`,
      { ...trimmed },
    );
  }

  /**
   * Busca os dados do Resumo de Itens de Guias com JSON pré-gerado.
   *
   * Inativo pelo mesmo motivo do `fetchDadosJsonPreGerado`.
   */
  fetchDadosResumoItensGuiasCuboJsonPreGerado({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<JsonPreGerado<LinhaResumoItemGuia>>>(
      `/consuta-json-pre-gerado/operadora/${regans}/consulta/MON_CR_GUIA_ITEM_RESUMO_V202403`,
      { ...params },
    );
  }

  fetchGuiasCnesGenerico({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<GuiaCnesGenerico>>(
      `/analises/conformidade/cnes-generico-incompativel/operadora/${regans}/guias-cnes-generico`,
      params,
    );
  }

  fetchGuiasCnesIncompativel({ regans, ...params }: OperadoraCompetenciaParams) {
    return this.get<ApiResponse<GuiaCnesIncompativel>>(
      `/analises/conformidade/cnes-generico-incompativel/operadora/${regans}/guias-cnes-incompativel`,
      params,
    );
  }

  fetchCnesGenericoIncompativelUltimoProcessamento({ regans }) {
    return this.get<ApiResponse<UltimoProcessamento>>(
      `/analises/conformidade/cnes-generico-incompativel/operadora/${regans}/ultima-atualizacao`,
    );
  }
}
